export const environment = {
  production: true,
  disableConsoleLogs: false,
  userURL: "https://dev-api.ourlane.com/users/v1",
  analyticsURL: "https://dev-api.ourlane.com/analytics/v1",
  // analyticsURL: "http://localhost:4003/analytics/v1",
  partnerAnalyticsURL: "https://dev-api.ourlane.com/partner/v1",
  paymentURL: "https://dev-api.ourlane.com/payments/v1",
  staticURL: "https://dev-api.ourlane.com/configurations/v1",
  // staticURL: "http://localhost:3005/configurations/v1",
  tripURL: "https://dev-api.ourlane.com/trips/v1",
  chatUrl: "https://dev-api.ourlane.com/communications/v1",
  trackURL: "https://dev-api.ourlane.com/tracking/v1",
  carURL: "https://dev-api.ourlane.com/cars/v1",
  personalAssistantURL: "https://dev-api.ourlane.com/assistant/v1",
  personalAssistantAnalyticsURL: "https://dev-api.ourlane.com/assistant/analytics/v1",
  copilotUrl: "https://dev-api.ourlane.com/copilot/v1",
  notificationURL: "https://dev-api.ourlane.com/notifications/v1",
  reportURL: "https://dev-api.ourlane.com/reports/v1",
  collectorUrl: "https://dev-api.ourlane.com/collector/v1",
  yachtUrl: "https://dev-api.ourlane.com/yacht/asset/v1",
  yachtBookingUrl: "https://dev-api.ourlane.com/yacht/booking/v1",
  yachtAnalyticsUrl: "https://dev-api.ourlane.com/yacht/analytics/v1",
  siteKey: "6LfT6N4nAAAAAGQljG3o_BcTnBpQOWmuob2YZYBi",
  socketURL: "https://dev-api.ourlane.com",
  alertUrl: "https://dev-api.ourlane.com/alerts/v1",
  configurationsUrl: "https://dev-api.ourlane.com/configurations/v1",
  rentalUrl: "https://dev-api.ourlane.com/rental/partner/v1",
  rentalAssetUrl: "https://dev-api.ourlane.com/rental/asset/v1",
  rentalBookingUrl: "https://dev-api.ourlane.com/rental/booking/v1",
  rentalAnalyticsUrl: "https://dev-api.ourlane.com/rental/analytics/v1",
  driverURL: "https://dev-api.ourlane.com/driver/v1",
  referralURL: "https://dev-api.ourlane.com/referral/v1",
  // referralURL: "http://localhost:4084/referral/v1",
  mapbox: {
    accessToken: "pk.eyJ1IjoibW9uaWljb3BzIiwiYSI6ImNsbTdtNDZvdzAyMmYzam81b2t3YnQ3aGMifQ.x-upIVaVpO5iXWoZ2hC-yQ",
  },
  ourFleetData: {
    portalUrl: "https://dev-admin.ourlane.com",
    greyCarLocation: "https://dev-img.ourlane.com/images/map/grey.png",
    blackCarLocation: "https://dev-img.ourlane.com/images/map/black.png",
    blueCarLocation: "https://dev-img.ourlane.com/images/map/blue.svg",
    greenCarLocation: "https://dev-img.ourlane.com/images/map/green.svg",
  },
  isPaEnabled: true,
  isMeetingEnabled: true,
  customerReferralSectionEnabled: false,
  isRentalReportEnabled: true,
  isYachtReportEnabled: true,
  /** Emails that skip reCAPTCHA and send blank captcha to auth API. */
  recaptchaSkipEmails: [
    "archanaadmin@yopmail.com",
    "vijayadmin@yopmail.com",
    "sahebaadmin@yopmail.com",
    "puneetadmin@yopmail.com",
  ] as string[],
};
